import { DataProvider } from "@refinedev/core";
import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { MedicineDigestFormValues } from "../Medicine-Digests/types";

const DIGESTS_URL = "/cms/medicine/digests";

export const medicineDigestsDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getApiUrl: () => apiUrl,
    getList: async ({ resource }) => {
      try {
        const { data } = await httpClient.get(DIGESTS_URL);
        const digests = data?.digests || [];

        return {
          data: digests,
          total: digests.length,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    getOne: async ({ id }) => {
      try {
        const { data } = await httpClient.get(`${DIGESTS_URL}/${id}`);

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    create: async ({ variables }) => {
      try {
        const { data } = await httpClient.post(DIGESTS_URL + "/upsert", {
          ...(variables as MedicineDigestFormValues),
          id: null,
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    update: async ({
      variables,
    }: {
      id: string;
      resource: string;
      variables: MedicineDigestFormValues;
    }) => {
      try {
        const { data } = await httpClient.post(
          DIGESTS_URL + "/upsert",
          variables
        );

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ id }) => {
      try {
        const { data } = await httpClient.post(`${DIGESTS_URL}/remove/${id}`);

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
